<db-dialog-wrapper [dialog]="this" [width]="'500px'">
  <div class="db-manual-optimization-dialog">
    <h1 [innerHTML]="'text_migrationFlowLowScoreManualOptimize' | dbText"></h1>
    <p [innerHTML]="'text_migrationFlowLowScoreManualOptimizeDesc' | dbText"></p>
    <a class="db-button db-button_info" (click)="close()"><span>{{'text_addPaymentMethodSubscriptionSuccessButton' | dbText}}</span></a>
  </div>
</db-dialog-wrapper>
